/** @format */

import template from './gb-raffle-draw-widget.html';
import './gb-raffle-draw-widget.scss';

export const GbRaffleDrawWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
        gbWidget: '^^',
    },
    controller: class GbRaffleDrawWidgetComponent {
        constructor($log, $ccRealtime, $gbRaffleDraw, $element, $window, $scope, $timeout, $rootScope) {
            'ngInject';

            this.$log = $log;
            this.$ccRealtime = $ccRealtime;
            this.$gbRaffleDraw = $gbRaffleDraw;
            this.$element = $element;
            this.$window = $window;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$rootScope = $rootScope;

            this.minColumns = 6;
            this.displayedNumber = 0;
            this.showingSpinner = true;
        }

        spinNumber(raffleDraw) {
            if (this.displayedNumber === raffleDraw.ticket_number) {
                this.displayedNumber = 0;

                this.$timeout(() => {
                    this.displayedNumber = raffleDraw.ticket_number;
                });
            } else {
                this.displayedNumber = raffleDraw.ticket_number;
            }
        }

        getWidgetHeight() {
            return this.$element[0].clientHeight;
        }

        setColumnHeight() {
            this.columnHeight = this.getWidgetHeight();
        }

        getWidgetCss() {
            let columnContainerStyles = '';

            if (this.gbWidget.widget.primary_color) {
                columnContainerStyles += `background-color: ${this.gbWidget.widget.primary_color};`;
            }

            if (this.gbWidget.widget.primary_text_color) {
                columnContainerStyles += `color: ${this.gbWidget.widget.primary_text_color};`;
            }

            return `
                ng-pokie[id="${this.gbWidget.widget.uuid}"] .ng-pokie-digit-column-container {
                    ${columnContainerStyles}
                }
            `;
        }

        setHeightWatcher() {
            this.resizeHandler = () => {
                this.$scope.$apply(() => {
                    this.setColumnHeight();
                });
            };

            angular.element(this.$window).on('resize', this.resizeHandler);
        }

        $onInit() {
            this.setColumnHeight();
            this.setHeightWatcher();

            this.newRaffleDrawHandler = (ev, data) => {
                if (data.raffle_item === this.gbWidget.widget.raffle_item) {
                    this.$log.info('Ticket drawn for raffle item', data);
                    this.spinNumber(data);
                }
            };

            this.$ccRealtime.on(this.$gbRaffleDraw.cache.opts.pusher_create, this.newRaffleDrawHandler);

            this.setPreviewListener();
        }

        $onDestroy() {
            angular.element(this.$window).off('resize', this.resizeHandler);
        }

        setPreviewListener() {
            if (this.gbApp.isEditMode()) {
                this.$rootScope.$on(this.gbApp.$raffleDrawPreviewEvent, (event, draw) => {
                    this.spinNumber(draw);
                    this.$timeout(() => {
                        this.$rootScope.$broadcast(this.gbApp.$raffleWinnerPreviewEvent, draw);
                    }, 4500);
                });
            }
        }
    },
};
